export const loadPredefinedFlow = (key) => {
  if (key === 'kyc-test') {
    return {
      name: 'Onboarding Cliente KYC Avanzado',
      nodes: [
        {
          id: '1',
          type: 'input',
          position: { x: 50, y: 50 },
          data: {
            label: 'Inicio del Proceso',
            type: 'informativo',
            configJson: JSON.stringify({
              text: 'Bienvenido al proceso de onboarding. Por favor, sigue los pasos.',
            }),
          },
        },
        {
          id: '2',
          type: 'default',
          position: { x: 50, y: 180 },
          data: {
            label: 'Datos Personales',
            type: 'formulario',
            configJson: JSON.stringify({
              fields: [
                { label: 'Nombre Completo', type: 'text' },
                { label: 'Fecha de Nacimiento', type: 'date' },
                { label: 'Nacionalidad', type: 'text' },
                { label: 'Estado Civil', type: 'select', options: ['Soltero', 'Casado', 'Divorciado'] },
              ],
            }),
          },
        },
        {
          id: '3',
          type: 'default',
          position: { x: 300, y: 180 },
          data: {
            label: 'Dirección y Contacto',
            type: 'formulario',
            configJson: JSON.stringify({
              fields: [
                { label: 'Dirección Completa', type: 'text' },
                { label: 'Provincia', type: 'text' },
                { label: 'Teléfono', type: 'tel' },
                { label: 'Correo Electrónico', type: 'email' },
              ],
            }),
          },
        },
        {
          id: '4',
          type: 'default',
          position: { x: 50, y: 330 },
          data: {
            label: 'Validación de Identidad',
            type: 'documento',
            configJson: JSON.stringify({
              fields: [
                { label: 'Subir Cédula o Pasaporte', type: 'file' },
                { label: 'Seleccionar tipo de documento', type: 'select', options: ['Cédula', 'Pasaporte'] },
              ],
            }),
          },
        },
        {
          id: '5',
          type: 'default',
          position: { x: 300, y: 330 },
          data: {
            label: 'Validación Biométrica',
            type: 'validacion',
            configJson: JSON.stringify({
              fields: [
                { label: 'Selfie en tiempo real', type: 'image-capture' },
                { label: 'Reconocimiento facial automático', type: 'checkbox' },
              ],
            }),
          },
        },
        {
          id: '6',
          type: 'default',
          position: { x: 50, y: 480 },
          data: {
            label: 'Actividad Económica',
            type: 'formulario',
            configJson: JSON.stringify({
              fields: [
                { label: 'Ocupación', type: 'text' },
                { label: 'Empresa / Negocio', type: 'text' },
                { label: 'Ingresos mensuales estimados', type: 'number' },
                { label: 'Moneda', type: 'select', options: ['USD', 'EUR', 'PAB'] },
              ],
            }),
          },
        },
        {
          id: '7',
          type: 'default',
          position: { x: 300, y: 480 },
          data: {
            label: 'Personas Políticamente Expuestas',
            type: 'formulario',
            configJson: JSON.stringify({
              fields: [
                { label: '¿Es usted una PEP?', type: 'radio', options: ['Sí', 'No'] },
                { label: 'Descripción (si aplica)', type: 'text' },
              ],
            }),
          },
        },
        {
          id: '8',
          type: 'output',
          position: { x: 180, y: 640 },
          data: {
            label: 'Términos y Confirmación',
            type: 'informativo',
            configJson: JSON.stringify({
              text: 'He leído y acepto los términos y condiciones. Confirmo que la información proporcionada es veraz.',
            }),
          },
        },
      ],
      edges: [
        { id: 'e1-2', source: '1', target: '2' },
        { id: 'e2-3', source: '2', target: '3' },
        { id: 'e3-4', source: '3', target: '4' },
        { id: 'e4-5', source: '4', target: '5' },
        { id: 'e5-6', source: '5', target: '6' },
        { id: 'e6-7', source: '6', target: '7' },
        { id: 'e7-8', source: '7', target: '8' },
      ],
    };
  }

  return null;
};
